import { Controller } from "@hotwired/stimulus"

// Ao conectar, marca todos os itens (clica no checkbox "marcar todos") e
// pré-seleciona uma opção do select bulk_acao, conforme o value `select`:
//   "first" → primeira opção (padrão)
//   "last"  → última opção
//   "<x>"   → opção cujo value === "<x>"
//
// O controller só deve ser instanciado quando a auto-seleção for desejada;
// os views condicionam o data-controller ao param relevante (ex.: situacao,
// pendente). Substitui os antigos pagamentos-auto-selecionar / cartoes-auto-marcar.
export default class extends Controller {
  static targets = ["marcarTodos", "bulkAcao"]
  static values = {
    delay: { type: Number, default: 300 },
    select: { type: String, default: "first" }
  }

  connect() {
    this._timeoutId = setTimeout(() => {
      this.marcarTodosTarget.click()
      const option = this._optionToSelect()
      if (option) option.selected = true
    }, this.delayValue)
  }

  disconnect() {
    if (this._timeoutId) clearTimeout(this._timeoutId)
  }

  _optionToSelect() {
    const options = Array.from(this.bulkAcaoTarget.options)
    if (options.length === 0) return null
    if (this.selectValue === "first") return options[0]
    if (this.selectValue === "last") return options[options.length - 1]
    return options.find((o) => o.value === this.selectValue) || null
  }
}
